<template>
<!-- TaskHistoryTable -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.task_history_title')" addclass="mt-4 w-full max-w-[1300px]">
		<div class="rounded-lg px-6 border-blue-500 pt-7 mx-6 grid justify-items-center">
			<div v-if="taskHistory" id="eny_dashboard_overview" class="pt-8">
				<ejs-grid ref="grid" :dataSource='taskHistory' gridLines='Both' :allowTextWrap='true' height='570' allowSorting='true' :sortSettings='sortOptions'>
					<e-columns>
						<e-column field='id' headerText='ID' :isPrimaryKey='true' :visible='false'></e-column>
						<e-column field='action' :headerText="$t('eny.action')" :dataSource='actions' foreignKeyValue='label' foreignKeyField='value'></e-column>
						<e-column field='text' :headerText="$t('eny.text')" width='300'></e-column>
						<e-column field='date' :headerText="$t('eny.date')" type="date" :format="{type: 'date', format: $t('eny.date_format')}" width='90'></e-column>
						<e-column field='responsible' :headerText="$t('eny.responsible')" :dataSource='admins' foreignKeyValue='label' foreignKeyField='value' width='200'></e-column>
						<e-column field='updated_at' :headerText="$t('eny.created_at')" type="date" :format="{type: 'date', format: $t('eny.date_time_format')}" width='150'></e-column>
						<e-column field='created_by' :headerText="$t('eny.created_by')" :dataSource='admins' foreignKeyValue='label' foreignKeyField='value' width='200'></e-column>
					</e-columns>
				</ejs-grid>
			</div>
		</div>
	</panel>
</div>
</template>

<script>
import {GridComponent, ColumnsDirective, ColumnDirective} from '@syncfusion/ej2-vue-grids';
import { mapGetters } from 'vuex';
import Panel from "../../Base/Panel.vue";
import useUtils from '../../hooks/useUtils';

export default {
	name: "DashboardTaskHistory",
	components: {
		'ejs-grid': GridComponent,
		'e-columns': ColumnsDirective,
		'e-column': ColumnDirective,
		'panel': Panel,
	},
	setup(){
		const { timeZoneOffsetOnInit } = useUtils();
		return {
			timeZoneOffsetOnInit
		}
	},
	data() {
		return {
			actions: JSON.parse(this.$t('eny.actions')),
			sortOptions: { columns: [{ field: 'updated_at', direction: 'Descending' }] },
			dateFormat: {type: 'date', format: 'dd.MM.yyyy'},
			datetimeFormat: {type: 'date', format: 'dd.MM.yyyy HH:mm:ss'},
		};
	},
	computed: {
		...mapGetters('customer', ['taskHistory', 'user', 'task']),
		...mapGetters('user', ['admins']),
	},
	watch: {
		'taskHistory': function(newVal) {
			newVal.forEach((value, index) => {
				this.taskHistory[index].date = this.timeZoneOffsetOnInit(value.date)
				this.taskHistory[index].updated_at = this.timeZoneOffsetOnInit(value.updated_at)
			})
		},
		'task': function() {
			this.$store.dispatch('customer/loadTaskHistory', this.user.id)
		},
	},
}
</script>

<style>
.e-grid .e-rowcell{
	font-size: 12px;
}
</style>
